import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "25",
  height: "20",
  viewBox: "0 0 25 20",
  fill: "none",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#money-bills-icon)"><path opacity="0.4" d="M20.3077 3.125H8C8 4.50684 6.89904 5.625 5.53846 5.625V10.625C6.89904 10.625 8 11.7432 8 13.125H20.3077C20.3077 11.7432 21.4087 10.625 22.7692 10.625V5.625C21.4087 5.625 20.3077 4.50684 20.3077 3.125ZM14.1532 11.875C12.4539 11.875 11.0763 10.196 11.0763 8.125C11.0763 6.05391 12.4539 4.375 14.1532 4.375C15.8526 4.375 17.2302 6.05391 17.2302 8.125C17.2302 10.196 15.8526 11.875 14.1532 11.875ZM1.84615 15.625V3.75C0.826539 3.75 0 4.58953 0 5.625V16.25C0 17.6306 1.10208 18.75 2.46154 18.75H19.0769C20.0965 18.75 20.9231 17.9105 20.9231 16.875H3.07692C2.39715 16.875 1.84615 16.3153 1.84615 15.625Z" fill="currentColor"></path><path d="M22.7693 1.25H5.53854C4.519 1.25 3.69238 2.08953 3.69238 3.125V13.125C3.69238 14.1605 4.519 15 5.53854 15H22.7693C23.789 15 24.6155 14.1605 24.6155 13.125V3.125C24.6155 2.08953 23.789 1.25 22.7693 1.25ZM22.7693 10.625C21.4087 10.625 20.3078 11.7432 20.3078 13.125H8.00008C8.00008 11.7432 6.89911 10.625 5.53854 10.625V5.625C6.89911 5.625 8.00008 4.50684 8.00008 3.125H20.3078C20.3078 4.50684 21.4087 5.625 22.7693 5.625V10.625Z" fill="currentColor"></path></g><defs><clipPath id="money-bills-icon"><rect width="24.6154" height="20" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const MoneyBillsIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  MoneyBillsIcon as default
};
//# sourceMappingURL=MoneyBillsIcon.vue.es.js.map
